import { createFileRoute } from '@tanstack/react-router';

import { PrintView } from '@/features/logbook';

export const Route = createFileRoute('/logbook/print')({
  component: PrintView,
});
